import { config } from '../config';
import { createRealtimeClient, type RealtimeClient } from './client';
import { createEcho } from './echo';

/**
 * The one socket the application opens (P0-WEB-05).
 *
 * A module singleton, for the same reason `portal-client.ts` is one and for one
 * more: a WebSocket is a resource, and building it inside a component means
 * React's StrictMode double-render in development creates two, discards one
 * without cleanup, and leaks an open connection per mount. Memoising it here
 * makes "create once" true rather than aspirational.
 *
 * Built lazily so importing this module does not read the environment or open a
 * connection — `config()` throws when the Reverb variables are missing, and a
 * test that never intended to connect should not have to care.
 */

let instance: RealtimeClient | undefined;

export function realtimeClient(): RealtimeClient {
  if (instance !== undefined) return instance;

  const { apiUrl, reverb } = config();
  instance = createRealtimeClient({ echo: createEcho({ reverb, apiUrl }) });
  return instance;
}

/** Tests only. Module-level state leaks between tests otherwise. */
export function resetRealtimeClient(): void {
  instance?.disconnect();
  instance = undefined;
}
